module.exports = __webpack_public_path__ + "static/media/picto_blue.653f9563.svg";